<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
      <v-col cols="4">
        <app-select-mapeamento
          :mapeamento="mapeamento"
          :mapeamentos="mapeamentos"
          @return="(value) => (mapeamento = value)"
        />
      </v-col>
    </v-row>
    <v-card-widget title="Dashboard">
      <div
        v-if="!mapeamento"
        slot="widget-content"
      >
        <app-alert
          type="info"
          message="Não há mapeamentos disponíveis."
        />
      </div>
      <div
        v-else-if="mapeamento && (!chefia && !substituicaoChefia) && mapeamento.mapeamentoImportado"
        slot="widget-content"
      >
        <app-alert
          type="info"
          :message="`Mapeamento importado através do mapeamento (${mapeamento.mapeamentoImportado.nome})`"
        />
      </div>
      <div
        v-else
        slot="widget-content"
      >
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VCardWidget from '@/components/VWidget';
import AppAlert from '@/components/core/AppAlert';
import AppSelectMapeamento from '@/components/core/AppSelectMapeamento';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardMapeamento',

  components: {
    VCardWidget,
    AppAlert,
    AppSelectMapeamento,
    AppTimeline,
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.mapeamento.usuarioMapeamento.chefia,
      substituicaoChefia: (state) => state.mapeamento.usuarioMapeamento.substituicaoChefia,
      subChefia: (state) => state.mapeamento.usuarioMapeamento.subChefia,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    mapeamento: {
      get() {
        return this.$store.state.mapeamento.mapeamento;
      },
      set(mapeamento) {
        const payload = { tipo: 'COMUM', mapeamento };
        this.$store.dispatch('mapeamento/setMapeamento', payload);
      },
    },
    mapeamentos() {
      return this.$store.state.mapeamento.mapeamentos;
    },
    timelineItens() {
      return [
        {
          visibilidade: this.mapeamento.inicioPerComportServidor && this.usuarioMapeamento.tipo === 'REGULAR',
          titulo: 'Competências Comportamentais',
          textos: [
            'As competências comportamentais se revelam a partir da interação diária com as pessoas do seu '
              + 'trabalho. Assim, nesta primeira etapa do programa de Gestão por Competências, vamos falar sobre '
              + 'os comportamentos que observamos no nosso ambiente de trabalho. As informações fornecidas aqui serão '
              + 'reunidas para que possamos construir, em conjunto, um instrumento de avaliação que será utilizado '
              + 'para promover o seu desenvolvimento profissional e o da instituição.',
          ],
          cor: 'success',
          icone: 'thumbs_up_down',
          link: '/mapeamento/comportamento',
          dataInicial: this.mapeamento.inicioPerComportServidor,
          dataFinal: this.mapeamento.fimPerComportServidor,
          exibeStatus: true,
        },
        {
          visibilidade: (this.chefia || this.substituicaoChefia) && this.usuarioMapeamento.tipo === 'REGULAR',
          titulo: 'Competências Técnicas',
          textos: [
            'As responsabilidades são as tarefas estratégicas de uma unidade. Para executá-las, é preciso ter '
              + 'uma ou mais competências técnicas. Assim, nesta etapa, você deve refletir sobre as atividades '
              + 'do seu setor que são relevantes para o alcance dos objetivos organizacionais. Os dados cadastrados '
              + 'irão ajudar a construir um instrumento de avaliação que será utilizado para promover o permanente '
              + 'desenvolvimento de pessoas na instituição.',
            'Então, quais são as tarefas estratégicas da sua unidade?',
          ],
          cor: 'secondary',
          icone: 'recent_actors',
          link: '/mapeamento/responsabilidade',
          dataInicial: this.mapeamento.inicioPerRespGestor,
          dataFinal: this.mapeamento.fimPerRespGestor,
          exibeStatus: true,
        },
        {
          visibilidade: (this.chefia || this.substituicaoChefia) && this.subChefia,
          titulo: 'Validação das Competências Técnicas',
          textos: [
            'Nesta última etapa do mapeamento, você deverá validar as responsabilidades indicadas pelos gestores '
              + 'de suas subunidades. O objetivo é consolidar o instrumento de avaliação e, mais que isso, '
              + 'fomentar a gestão da informação na instituição, considerando que tais informações direcionarão '
              + 'o conjunto de competências técnicas requeridas para o servidor desempenhar cada responsabilidade '
              + 'daquela unidade.',
          ],
          cor: 'secondary',
          icone: 'how_to_reg',
          link: '/mapeamento/validacao-responsabilidade',
          dataInicial: this.mapeamento.inicioPerRespChefiaSuperior,
          dataFinal: this.mapeamento.fimPerRespChefiaSuperior,
          exibeStatus: true,
        },
      ];
    },
  },
};
</script>
